import config from "../config";
import { getAuthHeader, refreshAuthToken } from "../services/authToken";

const AiStreamResponse = async (params, onChunk, onDone,apiUrl) => {
  let authHeader = getAuthHeader();
  if (!authHeader) {
    await refreshAuthToken();
    authHeader = getAuthHeader();
  }
  if (!authHeader) {
    throw new Error("Session expired. Please login again.");
  }

  const response = await fetch(`${config.localurl}${apiUrl}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': authHeader
    },
    body: JSON.stringify(params)
  });

  if (!response.ok) throw new Error('Failed to fetch AI response');

  const reader = response.body.getReader();
  const decoder = new TextDecoder();

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    onChunk(chunk);
  }

  if (onDone) onDone();
};

export default AiStreamResponse;
